module.exports = __webpack_public_path__ + "img/about_background.e38fea94.png";